import {IPagination} from "../../shared/interface";
import {requests} from "../../helpers/api.services";
import {DRIVER_REGISTRATION_URL} from "../../helpers/api.routes";
import {IDriverRegistration} from "./interface";

export const AdminDriverRegistrationService = {
    getAll: (params: IPagination, active?: boolean) => requests.get(`${DRIVER_REGISTRATION_URL}`, {...params, active}),
    getSingle: (id: number) => requests.get(`${DRIVER_REGISTRATION_URL}/${id}`),
    create: (payload: IDriverRegistration) => requests.post(`${DRIVER_REGISTRATION_URL}`, payload),
    update: (payload: IDriverRegistration, id: number) =>
        requests.post(`${DRIVER_REGISTRATION_URL}/${id}`, payload),
    delete: (id: number) => requests.delete(`${DRIVER_REGISTRATION_URL}/${id}`),
}